import React, { useEffect, useState } from "react";
import { RoutePath, apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useNavigate, useParams } from "react-router-dom";

function AddReviewPage() {
  const { homeApi } = apiPath;
  const { reviewList } = RoutePath;
  const navigate = useNavigate();

  // Form data
  const data = [
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      name: "image",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "name",
      required: false,
    },
    {
      elementType: "textField",
      label: "company Name",
      type: "Text",
      name: "companyName",
      required: false,
    },
    {
      elementType: "textField",
      label: "designation",
      type: "Text",
      name: "designation",
      required: false,
    },
    {
      elementType: "textField",
      label: "review",
      type: "Text",
      name: "review",
      required: false,
    },
  ];

  const update = async (data) => {
    const newData = { learnReview: data };

    const res = await updateData(homeApi, newData, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        navigate("/" + reviewList);
      }, 1000);
    }
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
}

export default AddReviewPage;
